import { createAction } from 'redux-actions';

import {
  BILLING_PLAN_SELECTED,
  BILLING_PLAN_RESET,
} from 'app/features/billing/actionTypes';

const billingPlanSelected = createAction(BILLING_PLAN_SELECTED);
const billingPlanReset = createAction(BILLING_PLAN_RESET);

export { billingPlanSelected, billingPlanReset };
